export default __webpack_public_path__ + "static/media/fish&chips-italic.05013110.woff";